import { render } from "./CommonAside.vue?vue&type=template&id=3063d5f3&scoped=true&ts=true"
import script from "./CommonAside.vue?vue&type=script&lang=ts"
export * from "./CommonAside.vue?vue&type=script&lang=ts"

import "./CommonAside.vue?vue&type=style&index=0&id=3063d5f3&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3063d5f3"]])

export default __exports__